module.exports = __webpack_public_path__ + "img/7.f31a8782.jpg";